// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-business-user-modal-modal_card-wxr25 {
  width: 340px;
  height: auto;
}

.add-business-user-modal-modal_content-UdpqB {
  padding: 0px 20px 20px;
}

.add-business-user-modal-modal_primaryButtonBase-Vvapl {
  margin-left: 32px;
}

.add-business-user-modal-textField_container-xBFqo {
  width: 100%;
  margin-top: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/customer/business-users/add-business-user-modal/add-business-user-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".modal_card {\n  width: 340px;\n  height: auto;\n}\n\n.modal_content {\n  padding: 0px 20px 20px;\n}\n\n.modal_primaryButtonBase {\n  margin-left: 32px;\n}\n\n.textField_container {\n  width: 100%;\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `add-business-user-modal-modal_card-wxr25`,
	"modal_content": `add-business-user-modal-modal_content-UdpqB`,
	"modal_primaryButtonBase": `add-business-user-modal-modal_primaryButtonBase-Vvapl`,
	"textField_container": `add-business-user-modal-textField_container-xBFqo`
};
export default ___CSS_LOADER_EXPORT___;
